import React, { createContext, useContext, useMemo } from 'react';
import { useTextFieldState } from 'common/hooks';

import { FilterContext as Context } from './types';

const FilterContext = createContext({} as Context);
export const useFilterContext = () => useContext(FilterContext);

interface Props {
  children: React.ReactNode;
}

export const FilterProvider = (props: Props) => {
  const [ searchString, changeSearchString,, resetSearchString ] = useTextFieldState();

  const value = useMemo(() => ({
    searchString,
    changeSearchString,
    resetSearchString
  }), [
    searchString,
    changeSearchString,
    resetSearchString
  ]);

  return (
    <FilterContext.Provider value={value}>{props.children}</FilterContext.Provider>
  );
};
